/** Theme context shape (TZ 8.12.3: dark mode by system preference with a manual toggle). */
import { createContext, useContext } from 'react';
import type { ColorScheme, ThemeTokenValues } from '../tokens/design_tokens';

export type ThemePreference = 'system' | 'light' | 'dark';

export interface ThemeContextValue {
  preference: ThemePreference;
  setPreference: (nextPreference: ThemePreference) => void;
  resolvedScheme: ColorScheme;
  /** Live token values for canvas charts; refreshed when the scheme or brand colour changes. */
  tokens: ThemeTokenValues;
  /** Company primary colour actually applied (null when default or rejected by the contrast check). */
  appliedBrandPrimary: string | null;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export class MissingThemeProviderError extends Error {
  constructor() {
    super('useTheme must be used inside <ThemeProvider>');
    this.name = 'MissingThemeProviderError';
  }
}

export function useTheme(): ThemeContextValue {
  const themeContextValue = useContext(ThemeContext);
  if (themeContextValue === null) {
    throw new MissingThemeProviderError();
  }
  return themeContextValue;
}
